module.exports = __webpack_public_path__ + "static/media/pledgeApp.2b73dbc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/images/pledgeApp.png
// module id = 427
// module chunks = 9